module.exports = __webpack_public_path__ + "templates.shopline_payment_v2_apple_pay_button-2e432588.html";